import { teachersConstants } from './constants';

var viewActions = require ('../../store/view.actions');
var notebookService = require ('./notebookApi');

export const notebookActions = {
  getCourseSubjectTools,
  getCourseSubjectNotebookItems,
  addCourseSubjectNotebookItem
  
};  


function getCourseSubjectTools( token, courseSubjectID ) { 
  return dispatch => {
       
          notebookService.getCourseSubjectTools( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_NOTEBOOK_TOOLS,
                        tools: json
                      }) ;
          } )
          
  }
}

function getCourseSubjectNotebookItems( token, courseSubjectID ) { 
  return dispatch => {
       
      notebookService.getCourseSubjectNotebookItems( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_NOTEBOOK_ITEMS,
                        items: json
                      }) ;
          } )
          
  }
}



function  addCourseSubjectNotebookItem ( token, courseSubjectID, personaID,  toolID,  evalTypeOptID, evalTypeValue , comments ) {
  return dispatch => {
          dispatch(viewActions.isLoadingModule('addCourseSubjectNotebookItem',true)) ;

          notebookService.addCourseSubjectNotebookItem ( token, courseSubjectID, personaID, toolID, 
            evalTypeOptID, evalTypeValue , comments )

          .then( json => {
                  dispatch( { 
                    type: teachersConstants.ADD_COURSE_NOTEBOOK_ITEM,
                    course_subject_id: courseSubjectID,
                    persona_id: personaID,
                    tool_id: toolID,
                    eval_type_opt_id: evalTypeOptID,
                    eval_type_value: evalTypeValue,
                    comments: comments,
                    
                  }) ;
                dispatch(viewActions.isLoadingModule('addCourseSubjectNotebookItem',false));
            } )
  }
}

